import React, { Component } from 'react'
import {
  DropdownButton, MenuItem, Navbar, Nav,
  NavItem, Accordion, NavDropdown,
} from 'react-bootstrap'
import { Link, browserHistory } from 'react-router'
import available from '../../../../i18n/available'
import TranslationsSwitch from '../../../components/Translation'
import { DIST_URL } from '../../../constants/api'
import '../../../../assets/styles/components/Header.scss'
import './Header.scss'

export default class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false,
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle(){
    this.setState({ expanded: !this.state.expanded })
  }

  onClickDropDown(e, item) {
    e.preventDefault()
    browserHistory.push(item)
  }

  onChangeLanguage(lang) {
    window.location.href = `${window.origin}?lang=${lang}`
  }

  render(){
    const { t } = this.props
    const {
      detail, phone, language, onLoadTranslations,
    } = this.props

    const items = [
      {
        id: 'empresa',
        title: t('EMPRESA'),
        options: [
          {
            name: t('About'),
            path: '/empresa',
          },  {
            name:t('Services'),
            path: '/servicios',
          },
        ],
      }, {
        id: 'infoYnov',
        title: t('INFORMACION_NOVEDADES'),
        options: [
          {
            name: t('Informes_de_Mercado_Inmobiliario'),
            path: '/informes-del-mercado-inmobiliario',
          }, {
            name:'Newsletters',
            path: '/newsletters',
          }, {
            name:t('Noticias'),
            path: '/noticias',
          }, {
            name:t('Barrios'),
            path: '/barrios',
          },
        ],
      },
    ]

    const itemsDetail = [
      {
        id: 'infoYnov',
        title: t('INFORMACION_NOVEDADES'),
        options: [
          { name:'Informes de Mercado Inmobiliario', path: '/informes-del-mercado-inmobiliario' },
          { name:'Newsletters', path: '/newsletters'}, { name:'Noticias', path: '/noticias' },
          { name:'Barrios', path: '/barrios'}
        ]
      }, {
        id: 'more',
        title: t('MAS'),
        options: [
          { name:t('RESIDENCIAL'), path: '/residencial' },
          { name:t('OFICINAS'), path: '/oficinas' },
          { name:t('LOCALES'), path: '/locales' },
          { name:t('INDUSTRIAS'), path: '/industrias' },
          // HIDE-HOTELS { name:t('HOTELES'), path: '/hoteles' },
          { name:t('CAMPOS'), path: '/campos'},
          { name:t('EMPRENDIMIENTO'), path: '/emprendimientos'},
          { name:t('TERRENOS'), path: '/terrenos'},
          { name:t('TASACIONES'), path: '/tasaciones', style:'red-font-color' },
        ]
      }
    ]

     let menuContent = detail ? itemsDetail : items

     let telephone = 'tel:+5411' + phone.replace('-', '')

    return (
      <div>
        <Navbar className='ljr-header' expanded={this.state.expanded} onToggle={this.toggle}>
          <Navbar.Header>
            <Navbar.Brand>
              <div className='hidden-xs'>
                <Link to='/'>
                  <img className='ljr-logo-desktop' src={DIST_URL+'/assets/images/logo_ljr.png'} alt='LJ Ramos' />
                </Link>
              </div>
              <div className='visible-xs'>
                <Link to='/'><img src={DIST_URL+'/assets/images/logo_ljr.png'} alt='LJ Ramos' /></Link>
              </div>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav pullRight className='top-right-menu-desktop hidden-xs hidden-xs'>
            <NavItem>
              <i className='fa fa-whatsapp' style={{fontSize: '15px'}}></i>
              <p className='menu-resalted'>
                <a
                  target='_blank'
                  href={`https://api.whatsapp.com/send?phone=54911${phone.replace(/\D+/g, '')}`}
                  rel='noreferrer'
                >
                  WhatsApp
                </a>
              </p>
            </NavItem>
            <NavItem>
              <i className='fa fa-phone'></i>
              <p className='menu-resalted'><a href={telephone}>(5411) - {phone}</a></p>
            </NavItem>
            <NavItem>
              <div className='languages-selector languages-selector-mobile'>
                <TranslationsSwitch
                  onChange={this.onChangeLanguage}
                  available={Object.keys(available)}
                  currentLanguage={language} />
              </div>
            </NavItem>
          </Nav>
          <Nav pullRight className='top-right-menu-container visible-xs visible-sm'>
            <div className='top-right-menu-mobile'>
              <div>
                <a
                  target='_blank'
                  href={`https://api.whatsapp.com/send?phone=54911${phone.replace(/\D+/g, '')}`}
                  rel='noreferrer'
                >
                  <i className='fa fa-whatsapp' style={{fontSize: '31px'}}></i>
                </a>
              </div>
              <div>
                <a href={telephone}><i className='fa fa-phone fa-lg' style={{fontSize: '30px'}}></i></a>
              </div>
              <div>
                <div className='languages-selector languages-selector-mobile'>
                  <TranslationsSwitch
                    onChange={onLoadTranslations}
                    available={Object.keys(available)}
                    currentLanguage={language} />
                </div>
              </div>
              <Navbar.Toggle className='btn-responsive' />
            </div>
          </Nav>
          <Navbar.Collapse>
            <Nav className='hidden-xs'>
              <div className='navbar-center top-left-menu-desktop'>
                {menuContent.map((item, index) =>
                  <div key={index}>
                    <DropdownButton bsStyle='link' title={item.title} id={item.id}>
                      {item.options.map((el, i) =>
                        (el.style) ? (
                          <MenuItem className={el.style} key={i} onClick={(e) => this.onClickDropDown(e,el.path)}>
                            {el.name}
                          </MenuItem>
                        ) : (
                          <MenuItem key={i} onClick={(e) => this.onClickDropDown(e,el.path)}>{el.name}</MenuItem>
                        )
                      )}
                    </DropdownButton>
                  </div>
                )}
              </div>
            </Nav>
            <Nav className='visible-xs'>
              <div className='navbar-center sandwich-menu'>
                <Accordion>
                  {/* <NavItem onClick={this.toggle}>
                    <Link className='link-header' to='/empresa'> {t('EMPRESA')} </Link>
                  </NavItem>
                  <NavItem onClick={this.toggle}>
                    <Link className='link-header' to='/servicios'> {t('Services')} </Link>
                  </NavItem> */}
                  <NavDropdown
                    className='mobile-menu-dropdown empresa' eventKey='3' title={t('EMPRESA')}
                  >
                    <MenuItem key={1} eventKey={1} href={'/empresa'}>
                      {t('About')}
                    </MenuItem>
                    <MenuItem key={2} eventKey={2} href={'/servicios'}>
                      {t('Services')}
                    </MenuItem>
                  </NavDropdown>
                  <NavDropdown
                    className='mobile-menu-dropdown novedades' eventKey='4' title={t('INFORMACION_NOVEDADES')}
                  >
                    <MenuItem key={2} eventKey={2} href={'/informes-del-mercado-inmobiliario'}>
                      {t('Informes_de_Mercado_Inmobiliario')}
                    </MenuItem>
                    <MenuItem key={3} eventKey={2} href={'/newsletters'}>
                      {t('Newsletters')}
                    </MenuItem>
                    <MenuItem key={4} eventKey={2} href={'/noticias'}>
                      {t('Noticias')}
                    </MenuItem>
                    <MenuItem key={5} eventKey={2} href={'/barrios'}>
                      {t('Barrios')}
                    </MenuItem>
                  </NavDropdown>
                </Accordion>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/commons/Header/Header.component.js